import { render, staticRenderFns } from "./PostFeedback.vue?vue&type=template&id=5f724c0f&"
import script from "./PostFeedback.vue?vue&type=script&lang=js&"
export * from "./PostFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports